import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import AdminDashboard from "./Pages/AdminDashboard";
import AttendanceHistory from "./Pages/AttendanceHistory";
import EmployeeProfile from "./Pages/EmployeeProfile";
import EmployeeProfileDeatails from "./Pages/EmployeeProfileDeatils";
import LeaveAttendance from "./Pages/LeaveAttendance";
import LeaveHistory from "./Pages/LeaveHistory";
import PrivacyPolicy from "./Pages/privacypolicy";
import Employee_Designation from "./Pages/Employee_Designation";
import SignupPage from "./Pages/SignupPage";
import LeadDashboard from "./Pages/LeadDashboard";

// const ProtectedRoute = ({ children }) => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!user) return <Navigate to="/" />;

//   if (user.role !== "lead")
//     return <Navigate to="/AdminDashboard" />;

//   return children;
// };
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" />;
}


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/AdminDashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AdminDashboard/AttendanceDashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance-history/:id"
          element={
            <ProtectedRoute>
              <AttendanceHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave-history/:userId"
          element={
            <ProtectedRoute>
              <LeaveHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="AdminDashboard/Profile"
          element={
            <ProtectedRoute>
              <EmployeeProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-profile/:id"
          element={
            <ProtectedRoute>
              <EmployeeProfileDeatails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AdminDashboard/leaveAttendance"
          element={
            <ProtectedRoute>
              <LeaveAttendance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/LeadDashboard"
          element={
            <ProtectedRoute>
              <LeadDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/LeadDashboard/leaveAttendance"
          element={<LeaveAttendance />}
        />
        <Route
          path="/AdminDashboard/PrivacyPolicy"
          element={
            <PrivacyPolicy />
          }
        />
        <Route
          path="/AdminDashboard/EmployeeDesignation"
          element={
            <ProtectedRoute>
              <Employee_Designation />
            </ProtectedRoute>
          }
        />


      </Routes>
    </BrowserRouter>
  );
}
